import colors from 'vuetify/lib/util/colors';

export default {
  light: {
    primary: '#631132',  // morena guinda
    secondary: 'white',  // Yellow Primary (parece que falta un número en el código hexadecimal)
    accent: "white",     // Red Primary (parece que falta un número en el código hexadecimal)
    bg_main: "white",

    //titulo y subtitulo de login y register
    title_login: "Procuraduría General de Justicia del Estado de Hidalgo",
    subtitle_login: "Plataforma de acceso a los tramites y servicios",
    color_name_tramite: '#101828',

    icons: {
      // EN USO MARZO 2025
      logo_flor3: 'img/flor_menu.svg',
      logo_flor2: 'img/flor_completa.svg',
      logo_flor: 'img/florecita.png',
      logo_tablet: 'img/tablet_logo.img',
      logo_footer2: 'img/logo_footer2.svg',
      logo_header: 'img/logo_procu.png',
      logo_footer: 'img/logo_footer_hidalgo.png',
      logo_navigation_postlogin: 'img/logo_procu.png',


      /*

      icon_portfolio: 'img/carrito.png',
      icon_test: '@/assets/icons/agricultura.svg',

      //###### DASHBOARD CARDS ICONS #####
      icon_home_card_1: 'img/pendiente_c.png',
      icon_home_card_2: 'img/proceso_c.png',
      icon_home_card_3: 'img/cancelado_c.png',
      icon_home_card_4: 'img/completado_c.png',

      // MAIN DRAWER NAVIGATION
      icon_new_process: 'img/nuevo_a.png',
      icon_new_process_selected: 'img/nuevo_b.png',
      icon_all: 'img/todo_a.png',
      icon_all_selected: 'img/todo_b.png',
      icon_pending: 'img/pendiente_a.png',
      icon_pending_selected: 'img/pendiente_b.png',
      icon_in_process: 'img/proceso_a.png',
      icon_in_process_selected: 'img/proceso_b.png',
      icon_canceled: 'img/cancelado_a.png',
      icon_canceled_selected: 'img/cancelado_b.png',
      icon_finished: 'img/completado_a.png',
      icon_fiished_selected: 'img/completado_b.png',
      icon_orders: 'img/ordenes_a.png',
      icon_orders_selected: 'img/ordenes_b.png',

      //PROCEDURES LIST
      icon_continue: 'img/continuar.png',
      icon_show_progress: 'img/progreso.png'
*/
    },

    // Tables
    title_table: '#98989A', // Purple Primary (parece que falta un número en el código hexadecimal)
    bg_table_th: '#691C32', // Indigo Primary
    txt_table_th: '#fff',
    bg_footer2: '#631132',


    // NavBar up
    bg_navbar: '621132',
    // NavBar left
    bg_navbar_: '#4C0D27',
    botoncolorsegundo: '#6D1D3E',
    txt_color_nav: 'white',

    //Footer
    bg_footer: 'linear-gradient(135deg, #64121a, #691b32)',
    //header
    bg_header: 'linear-gradient(135deg, #64121a, #691b32)',

    main_color_itens: 'white',

    color_text_nav: 'white',




    // Navigator drawers
    main_color: '#4C0D27',
    main_color_action: '#6D1D3E',

    //Appbar
    app_bar: '#621132',



//##### DASHBOARD TOP CARDS #####
    bg_home_card_1: '#DDC9A3',
    bg_home_card_1_avatar: '#DDC9A3',
    bg_home_card_1_title: '#DDC9A3',

    bg_home_card_2: '#28a9e2',
    bg_home_card_2_avatar: '#239cd3',
    bg_home_card_2_title: '#50b7e4',

    bg_home_card_3: '#f0605f',
    bg_home_card_3_avatar: '#f34d4f',
    bg_home_card_3_title: '#ef7b7c',

    bg_home_card_4: '#8dc73f',
    bg_home_card_4_avatar: '#72bc41',
    bg_home_card_4_title: '#a1cf62',

    //STATUS TEXT
    status_active: '#000000', // #f15a25
    status_process: '#f1c232', // #239cd3 anterior
    status_canceled: colors.pink.darken1,
    status_finished: '#72bc41',

    //btn_download_invoice: colors.orange.lighten2,

    error: colors.red.lighten1,
    warning: colors.orange.lighten1,
  },


}
